import React from 'react';
import { AppModal } from './AppModal';
import { Button, Form, Input, Space, Typography } from '../';

export const MFAModal = ({ open, onCancel, onFinish, isLoading = false }) => {
    const [form] = Form.useForm();

    return (
        <AppModal title="Two Factor Authentication" onCancel={onCancel} open={open} maskClosable={false} footer={null}>
            <Typography.Paragraph>
                We sent you the Verification Code. Please enter it in the field below.
            </Typography.Paragraph>

            <Form
                form={form}
                name="enter-mfa"
                layout="vertical"
                initialValues={{ remember: true }}
                style={{ maxWidth: 600 }}
                onFinish={onFinish}
            >
                <Form.Item
                    name="mfaCode"
                    label="Verification Code"
                    rules={[{ required: true, message: 'Please input the mfa code' }]}
                >
                    <Input placeholder="Verification Code" />
                </Form.Item>

                <Form.Item style={{ textAlign: 'right' }}>
                    <Space>
                        <Button key="cancel" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button key="submit" type="primary" loading={isLoading} htmlType="submit">
                            Submit Code
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </AppModal>
    );
};
